module.exports = __webpack_public_path__ + "static/media/nophoto.f98b32ce.png";